"use strict";

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (angular) {
  "use strict";

  angular.module("fleetviewApp").component("dashboard", {
    template: require("./dashboard.component.html"),
    controller: dashboardController
  });

  dashboardController.$inject = ["$scope", "$location", "$stateParams", "$state", "$q", "FleetViewDashboard", "GroupsService", "RouteReporterAPI"];

  function dashboardController($scope, $location, $stateParams, $state, $q, FleetViewDashboard, GroupsService, RouteReporterAPI) {
    var vm = this;

    var ChartOptions = function ChartOptions() {
      return {
        backgroundColor: "#f5f5f5",
        chartArea: {
          right: 10,
          left: 40,
          top: 20,
          bottom: 40
        },
        hAxis: {
          titleTextStyle: {
            bold: true,
            italic: false
          }
        },
        vAxis: {
          gridlines: {
            color: "#DDD"
          }
        },
        titlePosition: "out",
        legend: {
          position: "none"
        },
        tooltip: {
          isHtml: false
        },
        fontName: "Open Sans",
        height: 200
      };
    };

    vm.charts = [{
      "title": "Compliance Routes Received (by week)",
      "isLoading": false,
      "noData": false,
      "chart": null
    }, {
      "title": "Percent of OOR Miles (by Vehicle)",
      "isLoading": false,
      "noData": false,
      "chart": null
    }, {
      "title": "Percent of Routes with OOR Events",
      "isLoading": false,
      "noData": false,
      "chart": null
    }, {
      "title": "Ratio of OOR Miles (by week)",
      "isLoading": false,
      "noData": false,
      "chart": null
    }];

    google.charts.load("current", {
      packages: ["corechart"]
    });
    google.charts.setOnLoadCallback(init);

    function init() {
      console.log('init dashboard');

      // Properties
      vm.isLoading = true;
      vm.selectedGroupType = "Vehicle";
      vm.selectedGroup = null;

      // pagination properties
      vm.firstItemNum = 1;
      vm.lastItemNum = 10;
      vm.docsPerPage = 10;
      vm.currentPageNum = 1;
      vm.totalPagesNum = 1;
      vm.download = download;
      vm.getNextDocumentsPage = getNextDocumentsPage;
      vm.getPreviousDocumentsPage = getPreviousDocumentsPage;

      // stores the documents in the current page
      vm.docsList = [];

      _loadExportedDocuments();

      // load vehicle and driver groups once and keep them in memory. This may need to be reworked depending on the user interaction.
      $q.all([_loadDriverGroups(), _loadVehicleGroups()]).finally(function () {
        vm.selectedGroup = vm.allItems[0];
        vm.isLoading = false;
        $scope.$watch(function () {
          return vm.selectedGroupType;
        }, function (newValue, oldValue) {
          return _selectedGroupTypeChanged(newValue, oldValue);
        });
        $scope.$watch(function () {
          return vm.selectedGroup;
        }, function (newValue, oldValue) {
          return loadChartData(newValue);
        });
      });
    }

    function loadChartData(group) {
      _.each(vm.charts, function (c) {
        c.isLoading = true;
        c.noData = false;
        if (c.chart !== null) c.chart.clearChart();
      });
      if (group) {
        _loadOutOfRoutePercertange([group.groupId], vm.selectedGroupType);
        _loadOutOfRoutRatioReport(8, [group.groupId], vm.selectedGroupType);
        _loadOutOfRouteReport([group.groupId], vm.selectedGroupType);
        _loadRoutesByWeek(6, [group.groupId], vm.selectedGroupType);
        _loadSummary([group.groupId], vm.selectedGroupType);
      } else {
        _.each(vm.charts, function (c) {
          c.isLoading = false;
          c.noData = true;
        });
      }
    }

    function _loadExportedDocuments() {
      RouteReporterAPI.get("api/ExportQueue", null).then(function (response) {
        vm.exportedDocuments = _.map(response.data, function (data) {

          // parse date of export (from this format 2021-02-16T12:14:43 to 20210216121443)
          var separators = ['-', 'T', ':'];
          var dateExported = data.dateExported.split(new RegExp(separators.join('|'), 'g')).join('');

          return {
            identifier: data.identifier,
            displayName: "routereporterexport_" + dateExported,
            dateExported: data.dateExported,
            fileNames: data.fileNames,
            downloaded: data.dateDownloaded ? true : false
          };
        });
        _displayExportedDocuments();
      }, function (error) {
        console.log('error getting exported documents');
      });
    }

    function _displayExportedDocuments() {
      // sort newest to oldest export time
      vm.exportedDocuments.sort(function (d1, d2) {
        return d1.dateExported < d2.dateExported ? 1 : -1;
      });

      // find the total number of pages
      vm.totalDocsNum = vm.exportedDocuments.length;
      vm.totalPagesNum = Math.ceil(vm.totalDocsNum / vm.docsPerPage);

      // get docs to display on first page
      vm.docsList = [];
      if (vm.totalDocsNum > vm.docsPerPage) {
        vm.docsList = vm.exportedDocuments.slice(0, vm.docsPerPage);
      } else {
        vm.docsList = vm.exportedDocuments;
        vm.lastItemNum = vm.totalDocsNum;
      }
    }

    function getNextDocumentsPage() {
      vm.currentPageNum++;
      vm.docsList = [];

      var start = (vm.currentPageNum - 1) * vm.docsPerPage;
      var numRemainingDocs = vm.totalDocsNum - start;
      vm.firstItemNum = start + 1;

      if (numRemainingDocs > vm.docsPerPage) {
        vm.docsList = vm.exportedDocuments.slice(start, start + vm.docsPerPage);
        vm.lastItemNum = start + vm.docsPerPage;
      } else {
        vm.docsList = vm.exportedDocuments.slice(start, vm.totalDocsNum);
        vm.lastItemNum = vm.totalDocsNum;
      }
    }

    function getPreviousDocumentsPage() {
      vm.currentPageNum--;
      vm.docsList = [];

      var start = (vm.currentPageNum - 1) * vm.docsPerPage;
      vm.docsList = vm.exportedDocuments.slice(start, start + vm.docsPerPage);

      vm.firstItemNum = start + 1;
      vm.lastItemNum = start + vm.docsPerPage;
    }

    function download(doc) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var fileName = _step.value;

          RouteReporterAPI.get("download/csv/" + fileName, null).then(function (response) {
            var blob = new Blob([response.data], { type: 'octet/stream' });
            var uri = window.URL.createObjectURL(blob);

            // fileName format = {identifier}_{documentNumber}
            var documentNumber = fileName.split('_').slice(-1).pop();
            // save file as routereporterexport_{date/time}_{documentNumber}
            var formattedFileName = doc.displayName + "_" + documentNumber;
            saveFileAs(uri, formattedFileName);
            return doc.identifier;
          }).then(function (identifier) {
            RouteReporterAPI.get("acknowledge/download/" + identifier, null);
            if (doc.downloaded === false) {
              doc.downloaded = true;
            }
          }).catch(function () {
            return console.log('error downloading document');
          });
        };

        for (var _iterator = (0, _getIterator3.default)(doc.fileNames), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    function saveFileAs(uri, filename) {
      var link = document.createElement('a');
      if (typeof link.getAttribute('download') === 'string' || (0, _typeof3.default)(link.getAttribute('download')) === 'object') {
        link.style.display = "none";
        link.href = uri;
        link.setAttribute('download', filename);

        // Firefox requires the link to be in the body
        document.body.appendChild(link);

        // simulate click
        link.click();

        // remove the link when done
        document.body.removeChild(link);

        //release object url when done
        window.URL.revokeObjectURL(uri);
      } else {
        window.open(uri);
      }
    }

    function _loadDriverGroups() {
      var forceRefresh = true;
      return GroupsService.getDriverGroups(true).then(function (groups) {
        vm.driverGroups = groups.map(function (c) {
          return {
            groupId: c.id,
            groupName: c.name,
            numItems: c.numberOfDrivers
          };
        });

        // after loading driver groups, if this is what tab is currently selected, show the results
        if (vm.selectedGroupType === "Driver") {
          vm.allItems = vm.driverGroups;
          vm.selectedGroup = vm.allItems[0];
        }
      });
    }

    function _loadVehicleGroups() {
      var forceRefresh = true;
      return GroupsService.getVehicleGroups(forceRefresh).then(function (groups) {
        vm.vehicleGroups = groups.map(function (c) {
          return {
            groupId: c.id,
            groupName: c.name,
            numItems: c.numberOfVehicles
          };
        });

        // after loading vehicle groups, if this is what tab is currently selected, show the results
        if (vm.selectedGroupType === "Vehicle") {
          vm.allItems = vm.vehicleGroups;
          vm.selectedGroup = vm.allItems[0];
        }
      });
    }

    function _selectedGroupTypeChanged(newValue, oldValue) {
      // whenever the tab between vehicle and driver groups changes, set those as the current groups
      if (newValue === "Vehicle") {
        vm.allItems = vm.vehicleGroups || [];
        vm.selectedGroup = vm.allItems[0];
      } else {
        vm.allItems = vm.driverGroups || [];
        vm.selectedGroup = vm.allItems[0];
      }

      vm.charts[1].title = "Percent of OOR Miles (by " + newValue + ")";

      var element = document.getElementById("groupsList");
      if (element) {
        element.scrollTop = 0;
      }
    }

    function _loadRoutesByWeek(weeks, groupIds, groupType) {
      return FleetViewDashboard.getRoutesByWeek(weeks, groupIds, groupType).then(function (res) {
        if (vm.charts[0].chart === null) vm.charts[0].chart = new google.visualization.ColumnChart(document.getElementById("chart-0"));
        var chart = vm.charts[0].chart;
        vm.charts[0].isLoading = false;
        if (res.length > 1) {
          var header = res[0];
          header.push({
            "role": "annotation"
          });
          var rows = _.map(res.slice(1), function (r) {
            return [r[0], parseInt(r[1]), parseInt(r[1])];
          });
          rows.unshift(header);
          var data = google.visualization.arrayToDataTable(rows);
          // Set chart options
          var options = new ChartOptions();
          options.hAxis.slantedText = true;
          chart.draw(data, options);
        } else {
          vm.charts[0].noData = true;
        }
      });
    }

    function _loadOutOfRouteReport(groupIds, groupType) {
      return FleetViewDashboard.getOutOfRouteReport(groupIds, groupType).then(function (res) {
        if (vm.charts[1].chart === null) vm.charts[1].chart = new google.visualization.BarChart(document.getElementById("chart-1"));
        var chart = vm.charts[1].chart;
        vm.charts[1].isLoading = false;
        if (res.length > 1) {
          var header = [res[0][0], res[0][3], {
            "role": "annotation"
          }, {
            "type": "string",
            "role": "tooltip",
            "p": {
              "html": true
            }
          }];
          var rows = _.map(res.slice(1), function (r) {
            var tooltip = "<div class=\"chart-tooltip\">" + "<strong>" + vm.selectedGroupType + " ID: </strong>" + r[0] + "<br/>" + "<strong>On-Route Miles: </strong>" + r[1] + "<br/>" + "<strong>OOR Miles: </strong>" + r[2] + "<br/>" + "<strong>OOR Percent: </strong>" + parseFloat(r[3]).toFixed(1) + "%</div>";
            return [r[0], parseFloat(r[3]), parseFloat(r[3]).toFixed(1) + "%", tooltip];
          });
          rows.unshift(header);
          var data = google.visualization.arrayToDataTable(rows);
          // Set chart options
          var options = new ChartOptions();
          options.tooltip.isHtml = true;
          options.chartArea.left = 70;
          options.chartArea.right = 30;
          options.colors = ["#ff9e21"];
          options.chartArea.bottom = 20;
          chart.draw(data, options);
        } else {
          vm.charts[1].noData = true;
        }
      });
    }

    function _loadOutOfRoutePercertange(groupIds, groupType) {
      return FleetViewDashboard.getOutOfRoutePercertange(groupIds, groupType).then(function (res) {
        if (vm.charts[2].chart === null) vm.charts[2].chart = new google.visualization.PieChart(document.getElementById("chart-2"));
        var chart = vm.charts[2].chart;
        vm.charts[2].isLoading = false;
        var withOORVal = parseFloat(res[1][1]);
        var withoutOORVal = parseFloat(res[2][1]);
        if (res.length > 1 && withOORVal > 0 && withoutOORVal > 0) {
          var header = res[0];

          var rows = [[res[1][0], withOORVal], [res[2][0], withoutOORVal]];
          rows.unshift(header);
          var data = google.visualization.arrayToDataTable(rows);
          // Set chart options
          var options = new ChartOptions();
          options.colors = ["#cf6c6c", "#49b54b"];
          options.legend.position = "right";
          options.chartArea.bottom = 10;
          chart.draw(data, options);
        } else {
          vm.charts[2].noData = true;
        }
      });
    }

    function _loadOutOfRoutRatioReport(weeks, groupIds, groupType) {
      return FleetViewDashboard.getOutOfRouteRatioReport(weeks, groupIds, groupType).then(function (res) {
        vm.charts[3].chart = new google.visualization.SteppedAreaChart(document.getElementById("chart-3"));
        var chart = vm.charts[3].chart;
        vm.charts[3].isLoading = false;
        if (res.length > 1) {
          var header = [res[0][0], "OOR Miles", "On Route Miles"];
          var rows = _.map(res.slice(1), function (r) {
            return [r[0], parseFloat(r[2]), parseFloat(r[1])];
          });
          rows.unshift(header);
          var data = google.visualization.arrayToDataTable(rows);
          // Set chart options
          var options = new ChartOptions();
          options.hAxis.slantedText = true;
          options.isStacked = "percent";
          options.connectSteps = false;
          options.colors = ["#cf6c6c", "#49b54b"];
          chart.draw(data, options);
        } else {
          vm.charts[3].noData = true;
        }
      });
    }

    function _loadSummary(groupIds, groupType) {
      return FleetViewDashboard.getSummary(groupIds, groupType).then(function (res) {
        vm.fleetSummary = res.fleetStats;
      });
    }
  }
})(window.angular);


// WEBPACK FOOTER //
// ./app/dashboard/dashboard.controller.js